export interface CampoGateway {
  chave: string;
  rotulo: string;
  segredo: boolean;
  multilinha?: boolean;
}

export interface ItemCatalogoGateway {
  id: string;
  nome: string;
  editavel: boolean;
  metodos: string[];
  campos: CampoGateway[];
}

const ROTULOS_METODO: Record<string, string> = {
  pix: 'Pix',
  boleto: 'Boleto',
  cartao: 'Cartão',
};

export function rotuloMetodos(metodos: string[]): string {
  return metodos.map((metodo) => ROTULOS_METODO[metodo] || metodo).join(', ');
}

export function urlWebhook(cnpj: string, gatewayId: string, ambiente: 'homologacao' | 'producao'): string {
  const teste = process.env.REACT_APP_ENVIRONMENT === 'test';
  const projeto = teste
    ? process.env.REACT_APP_FIREBASE_TEST_PROJECT_ID
    : process.env.REACT_APP_FIREBASE_PROJECT_ID;
  return `https://us-central1-${projeto}.cloudfunctions.net/webhookGateway?empresa=${cnpj}&gateway=${gatewayId}&ambiente=${ambiente}`;
}

export const CATALOGO_GATEWAYS: ItemCatalogoGateway[] = [
  {
    id: 'asaas',
    nome: 'Asaas',
    editavel: true,
    metodos: ['pix', 'boleto', 'cartao'],
    campos: [
      { chave: 'token', rotulo: 'Token da API', segredo: true },
    ],
  },
  {
    id: 'inter',
    nome: 'Banco Inter',
    editavel: true,
    metodos: ['pix'],
    campos: [
      { chave: 'clientId', rotulo: 'Identificador do cliente', segredo: false },
      { chave: 'clientSecret', rotulo: 'Segredo do cliente', segredo: true },
      { chave: 'chavePix', rotulo: 'Chave Pix', segredo: false },
      { chave: 'certificado', rotulo: 'Certificado', segredo: true, multilinha: true },
      { chave: 'chavePrivada', rotulo: 'Chave privada', segredo: true, multilinha: true },
    ],
  },
  { id: 'efi', nome: 'Efí', editavel: false, metodos: ['pix', 'boleto', 'cartao'], campos: [] },
  { id: 'iugu', nome: 'Iugu', editavel: false, metodos: ['pix', 'boleto', 'cartao'], campos: [] },
  { id: 'pagarme', nome: 'Pagar.me', editavel: false, metodos: ['pix', 'boleto', 'cartao'], campos: [] },
  { id: 'mercadopago', nome: 'Mercado Pago', editavel: false, metodos: ['pix', 'cartao'], campos: [] },
  { id: 'cielo', nome: 'Cielo', editavel: false, metodos: ['cartao'], campos: [] },
  { id: 'rede', nome: 'Rede', editavel: false, metodos: ['cartao'], campos: [] },
];
